import React from "react";
import { Link } from "react-router-dom";

export default function AddReloadButton({ companyId }) {
  return (
    <div className="field" style={{ marginTop: "15px" }}>
      <Link
        to={`/companies/${companyId}/sms-reloads/add`}
        className="button  is-link is-small"
      >
        <span className="icon">
          <i className="fas fa-eye" />
        </span>
        <span>Add SMS Reload</span>
      </Link>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/Company/SmsReload/ReloadButton.js